/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedNullSearchResultsHeader_itemSearch = {
    readonly searchTerm: string | null;
    readonly " $refType": "SbSharedNullSearchResultsHeader_itemSearch";
};
export type SbSharedNullSearchResultsHeader_itemSearch$data = SbSharedNullSearchResultsHeader_itemSearch;
export type SbSharedNullSearchResultsHeader_itemSearch$key = {
    readonly " $data"?: SbSharedNullSearchResultsHeader_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedNullSearchResultsHeader_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedNullSearchResultsHeader_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "searchTerm",
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '1984dca08801ef4e0a2d528577b36662';
export default node;
